import React, { useCallback, useRef } from "react";
import { toast } from "react-toastify";
import api from "../Api/api";

export default function useOnClientUnlink(
  id: string,
  name: string,
  refresh: () => Promise<void>
) {
  const toastId = useRef<any>(null);
  return useCallback(
    async (e: React.MouseEvent<HTMLElement>) => {
      e.preventDefault();
      e.stopPropagation();
      if (toast.isActive(toastId.current)) return;
      toastId.current = toast(
        `Are you sure you want to unlink ${name}? Click here to unlink.`,
        {
          type: "error",
          autoClose: 15000,
          position: "top-center",
          onClick: async () => {
            const allClients = await api.getClients();
            if (allClients.length === 1) {
              toast(
                "You have only one client. If you delete it, your account will be deleted. Do you accept?",
                {
                  type: "error",
                  autoClose: 15000,
                  position: "top-center",
                  onClick: async () => {
                    await api.deleteUserAccount();
                    toast("Account deleted!", { type: "success" });
                  },
                }
              );
            } else {
              await api.unlinkClient(id);
              toast("Client unlinked!", { type: "success" });
              refresh();
            }
          },
        }
      );
    },
    [id, name, refresh]
  );
}
